import cloneDeep from 'lodash/cloneDeep';
import lowerCase from 'lodash/lowerCase';
import isArray from 'lodash/isArray';

// eslint-disable-next-line import/no-cycle
import { iterateByArray } from 'shared/functions/utils';

export const upperFirst = (string: string) => string.charAt(0).toUpperCase() + string.slice(1);

export const replaceCompanyName = (companyName: string) => (message) => ({
  ...message,
  content:
    typeof message.content === 'string' ? message.content.replace(/\${companyName}/g, companyName) : message.content,
});

export const onlyAlphanumeric = (value: string) => (value || '').replace(/[^A-Za-z0-9]/g, '');

export const stringifyArrays = (items) => {
  const values = cloneDeep(items);

  iterateByArray(values, (key, value) => {
    if (lowerCase(key).includes('ids') && isArray(value)) {
      return value.join(',');
    }
  });

  return values;
};

export const getValidHtmlIdFromString = (value: string) => {
  const id = value ? value.toLowerCase().trim().replace(/\W/g, '_') : '_';
  return id.charAt(0).match(/[\d_]/g)?.length ? `id_${id}` : id;
};
